export default __webpack_public_path__ + "static/media/iso2pk.2d60aab9.svg";